import React from "react";
import styles from "./index.scss";
import { Field } from "redux-form/immutable";
import PropTypes from "prop-types";
import IPropTypes from "react-immutable-proptypes";
import FormField from "form-field";
import { login } from "cognito-redux/actions";
import AutobindComponent from "autobind-component";
import LoginForm from "login-form";
import { FORM_NAME } from "./constants";
import validate from "./validate";
import Header from "header";

const MFASection = ({ t }) => {
  return (
    <fieldset>
      <Field
        required={true}
        component={FormField}
        type="text"
        name="mfaCode"
        label={t("login:mfa_code")}
      />
    </fieldset>
  );
};

const NewPasswordSection = ({ t }) => {
  return (
    <fieldset>
      <Field
        required={true}
        component={FormField}
        type="password"
        name="newPassword"
        label={t("login:new_password")}
      />
    </fieldset>
  );
};

const LoginSection = ({ t }) => {
  return (
    <div>
      <Field
        key="username"
        id="username"
        component={FormField}
        type="text"
        name="username"
        label={t("login:username")}
      />
      <br key="linebreak" />
      <Field
        key="password"
        id="password"
        component={FormField}
        type="password"
        name="password"
        label={t("login:password")}
      />
    </div>
  );
};

const AdditionalAttributesSection = ({ attributesRequired, t }) => {
  return (
    <fieldset>
      {attributesRequired.map((attr, i) => (
        <div key={`${attr}:${i}`}>
          <Field
            required={true}
            component={FormField}
            type="text"
            name={`attributesData.${attr}`}
            label={t(`login:${attr}`)}
          />
        </div>
      ))}
    </fieldset>
  );
};

class Login extends AutobindComponent {
  render() {

   localStorage.clear();

    const {
      t,
      newPasswordRequired,
      attributesRequired,
      mfaRequired
    } = this.props;

    const loginRequired =
      !newPasswordRequired && !attributesRequired && !mfaRequired;

    return (
      <div>
        <Header />
        <div className={styles.loginPage}>
          <LoginForm
            onSubmit={login}
            validate={validate}
            form={FORM_NAME}
            submitLabel={t("login:login")}
          >
            {formsProps => [
              loginRequired ? (
                <LoginSection key="loginSection" {...formsProps} />
              ) : null,
              newPasswordRequired ? (
                <NewPasswordSection key="newPasswordSection" {...formsProps} />
              ) : null,
              attributesRequired ? (
                <AdditionalAttributesSection
                  key="additionalAttrSection"
                  {...formsProps}
                  {...this.props}
                />
              ) : null,
              mfaRequired ? (
                <MFASection key="mfaSection" {...formsProps} />
              ) : null
            ]}
          </LoginForm>

          <div className={ styles.links }>
            <a href="https://www.smokescreengame.org/tou" target="_blank" without rel="noopener noreferrer">Terms of Use</a>
            <div className={ styles.space }></div>
            <a href="https://www.smokescreengame.org/privacy-policy" target="_blank" without rel="noopener noreferrer">Privacy Policy</a>
          </div>
        </div>
      </div>
    );
  }
}

LoginSection.propTypes = MFASection.propTypes = AdditionalAttributesSection.propTypes = NewPasswordSection.propTypes = Login.propTypes = {
  t: PropTypes.func.isRequired,
  newPasswordRequired: PropTypes.bool,
  attributesRequired: PropTypes.arrayOf(PropTypes.string),
  mfaRequired: IPropTypes.mapContains({
    session: PropTypes.string.isRequired
  })
};

export default Login;



// WEBPACK FOOTER //
// ./src/login/login.presentation.jsx